import {LOGIN_ROUTES, OTHER_ROUTES} from "@/constants/routes";

export const isHomeUrl = ($route: any): boolean => $route.name === OTHER_ROUTES.HOME;
export const isRegisterStandardUrl = ($route: any): boolean => $route.name === LOGIN_ROUTES.REGISTER;
export const isRegisterPhoneAndCodeUrl = ($route: any): boolean => $route.name === LOGIN_ROUTES.REGISTER_PHONE;
export const isRegisterEmailAndCodeUrl = ($route: any): boolean => $route.name === LOGIN_ROUTES.REGISTER_EMAIL;
export const isRegisterEmailAndPhoneCodeUrl = ($route: any): boolean =>
  $route.name === LOGIN_ROUTES.REGISTER_EMAIL_PHONE;
export const isResetUrl = ($route: any): boolean => $route.name === LOGIN_ROUTES.RESET;

export const isLoginUrl = ($route: any): boolean => $route.name === LOGIN_ROUTES.LOGIN;
export const isRegisterUrl = ($route: any): boolean => isRegisterStandardUrl($route)
                                                   ||  isRegisterPhoneAndCodeUrl($route)
                                                   ||  isRegisterEmailAndCodeUrl($route)
                                                   ||  isRegisterEmailAndPhoneCodeUrl($route);

export const isValidationUrl = ($route: any): boolean => $route.name === LOGIN_ROUTES.VALIDATION;


export const isLoginRegisterResetOrValidationUrl = ($route: any): boolean => isLoginUrl($route)
                                                       ||  isRegisterUrl($route)
                                                       ||  isResetUrl($route)
                                                       ||  isValidationUrl($route);

